import { EventDrivenStore } from '@core/store/eventDrivenStore';
import constants from '@core/utils/constants';

class Store extends EventDrivenStore {
  constructor() {
    const defaultState = {
      bookmakerData: {},
      bookmakerIdConfirmation: {},
      bookmakerIdSetting: {}
    };

    super('bookmaker', defaultState, {
      useLocalStorage: true
    });
    this.defaultState = defaultState;
  }

  async setupEvents() {
    this.on(constants.EVENTS.BOOKMAKER.DETAIL.REFRESHING, (data) => {
      const bookmakerId = data.bookmakerId;
      const bookmaker = data.bookmaker;
      this.state.bookmakerData[`${bookmaker}_${bookmakerId}`] = {
        loading: true,
        data: null,
        error: null
      };
    });

    this.on(constants.EVENTS.BOOKMAKER.DETAIL.REFRESHED, (data) => {
      const bookmakerId = data.bookmakerId;
      const bookmaker = data.bookmaker;
      this.state.bookmakerData[`${bookmaker}_${bookmakerId}`] = {
        data: data,
        loading: false,
        error: null
      };
    });

    this.on(constants.EVENTS.BOOKMAKER.DETAIL.REFRESH_ERROR, (error) => {
      const bookmakerId = error.bookmakerId;
      const bookmaker = error.bookmaker;
      this.state.bookmakerData[`${bookmaker}_${bookmakerId}`] = {
        loading: false,
        error: error?.message || error,
        data: null
      };
    });

    this.on(constants.EVENTS.BOOKMAKER.REQUEST_ACCOUNT_CONFIRMATION, (data) => {
      const bookmakerInfo = constants.BOOKMAKER.INFOS?.[data.bookmaker];
      this.state.bookmakerIdConfirmation = {
        bookmaker: data.bookmaker,
        bookmakerId: data.bookmakerId,
        bookmakerName: bookmakerInfo?.name,
        bookmakerLogo: bookmakerInfo?.logo,
        bookmakerIdPageScreenshot: bookmakerInfo?.idScreenshot
      };
    });

    this.on(constants.EVENTS.BOOKMAKER.REQUEST_BOOKMAKER_ID_CHANGE, (data) => {
      const bookmakerInfo = constants.BOOKMAKER.INFOS?.[data.bookmaker];
      this.state.bookmakerIdSetting = {
        bookmaker: data.bookmaker,
        bookmakerId: data.bookmakerId,
        bookmakerName: bookmakerInfo?.name,
        bookmakerLogo: bookmakerInfo?.logo,
        bookmakerIdPageScreenshot: bookmakerInfo?.idScreenshot
      };
    });
  }
}

export default Store;
// new Store();
